import React, { useState ,useEffect } from 'react'

//-- UI
import { Progress } from "antd";

//! *** Image Saver ***
interface ImageSaverProps {
    enabled: boolean;
    queueTime: number; //! queue time in seconds, 0=no queue
    onDownload: () => boolean; //! called after queue and before triggering the download
    onQueue: (isRunning: boolean) => void; //! called with true at queue start, with false at queue end
}

const ImageSaver: React.FC<ImageSaverProps> = ({ enabled ,queueTime ,onDownload ,onQueue }) => {

//-- QUEUE
    const [progress, setProgress] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    function Submit() {
        if( !onDownload || onDownload() ) {
            document.getElementById('submitID').click();
        }
    }

    useEffect(() => {
        if( onQueue ) {
            onQueue(isRunning);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRunning]);

    //--
    useEffect(() => {
        let timer;

        const delay = queueTime * 1000;

        if( isRunning && progress < 100 ) {
            timer = setInterval(() => {
                setProgress((prev) => Math.min(prev + 1, 100)); // Increment progress
            }, delay/100 );
        }

        if( isRunning && progress === 100 ) {
            setTimeout(() => {  // Trigger click after 1 second
                Submit();
                setIsRunning(false);
           }, 1000 );
        }

        return () => {
            clearInterval(timer); 
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRunning, progress]);

    const startProgress = () => {       
        if( onDownload && !onDownload() ) return;

        if( queueTime ) {
            setIsRunning(true);
            setProgress(0); // Reset progress on start    
        } else {
            Submit();
        }
    };

//-- COMPONENT    
    return (
        <>
        {!isRunning && enabled && ( <div>
            <button disabled={!enabled} type="button" class="process-button" onClick={startProgress}> Download </button> 
            </div>
        )}
        {isRunning && ( <div>
            <Progress type="circle" percent={progress} size={60}/>
            <label class="padded-left"> Preparing download... upgrade to remove queue time.</label>
        </div> )}
        <button id="submitID" class="hidden" type="submit"/>        
        </>
    );
};

export default ImageSaver;